@if(!isOnHome){
    <div class="page-title-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="page-title-content text-white">
                        <h2>À propos</h2>
                        <ul class="text-gray-200">
                            <li><a routerLink="/" class="hover:underline">Accueil</a></li>
                            <li>À propos</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

<div class="container py-5">
    <div class="section-title">
        @if(isOnHome){
            <h2>À propos d’ASESA</h2>
            <div class="bar"></div>
        }
        <p>
            <strong>ASESA</strong> (Aide pour la santé, l’éducation et le sport en Afrique) est une association
            apolitique et à but non lucratif qui œuvre pour améliorer durablement les conditions de vie des
            communautés à la base, en particulier dans les zones rurales les plus défavorisées.
        </p>
    </div>

    <div class="row align-items-start">
        <div class="col-lg-6 col-md-12 mb-4">
            <div class="about-content">
                <h3>🎯 Notre mission</h3>
                <p>
                    Promouvoir durablement la <strong>santé</strong>, l’<strong>éducation</strong>, le <strong>développement social</strong>
                    et le <strong>bien-être</strong> des communautés à la base, surtout dans les zones rurales les plus défavorisées.
                </p>

                <h3>🎯 Nos objectifs</h3>
                <ul>
                    <li><strong>Santé :</strong> appuyer le renforcement des plateaux techniques des centres de santé publics et parapublics.</li>
                    <li><strong>Accès aux soins :</strong> faciliter l’accès aux soins de santé pour les communautés rurales.</li>
                    <li><strong>Éducation :</strong> accroître les capacités d’accueil des écoles primaires et secondaires.</li>
                    <li><strong>Inclusion :</strong> promouvoir les actions d’inclusion au sein des communautés.</li>
                    <li><strong>Climat :</strong> renforcer la résilience face aux changements climatiques.</li>
                    <li><strong>Réussite scolaire :</strong> promouvoir les mécanismes de rétention des apprenant(e)s dans leur cursus.</li>
                    <li><strong>Eau, hygiène & assainissement :</strong> promouvoir l’hygiène, l’assainissement et l’accès à l’eau potable.</li>
                    <li><strong>Leadership féminin :</strong> encourager le leadership des femmes au sein des communautés.</li>
                    <li><strong>Culture :</strong> promouvoir le patrimoine culturel en Afrique.</li>
                    <li><strong>Sport :</strong> promouvoir les activités sportives comme levier d’épanouissement et de cohésion.</li>
                </ul>
            </div>
        </div>

        <div class="col-lg-6 col-md-12 mb-4">
            <div class="about-content">
                <h3>🤝 Notre approche</h3>
                <p>
                    Pour atteindre ses objectifs, ASESA agit à travers des <strong>réunions d’échange</strong>, des
                    <strong>sensibilisations</strong>, des <strong>formations/recyclages</strong>, l’<strong>initiation de projets</strong>,
                    des <strong>appuis techniques et matériels</strong> ainsi que des actions de <strong>suivi-évaluation</strong>.
                </p>

                <h3>👥 Nos bénéficiaires</h3>
                <p>
                    Notre action s’adresse prioritairement aux <strong>communautés rurales</strong> et aux populations
                    vulnérables, avec une attention particulière pour les zones les plus défavorisées.
                </p>

                <h3>💡 Notre devise</h3>
                <p><em>"Agir ensemble pour des communautés en meilleure santé, mieux éduquées et plus résilientes."</em></p>

                <h3>🌱 Nos valeurs</h3>
                <ul class="list-unstyled">
                    <li>✔ Solidarité & entraide</li>
                    <li>✔ Inclusion & dignité humaine</li>
                    <li>✔ Neutralité (association apolitique)</li>
                    <li>✔ Durabilité & responsabilité locale</li>
                    <li>✔ Collaboration avec les acteurs publics et privés</li>
                </ul>
            </div>
        </div>
    </div>
</div>
